import { getServerURL } from 'src/modules/debug/utils';
// ponytail: lazy — module-level template would freeze "undefined/file/upload"
// if RNUC isn't ready at import time.
export const getUploadURL = () => `${getServerURL()}/file/upload`;
